import { Question } from '../models/Question'

export const createQuestionChoice = (
  question: Omit<Question<'choice'>, 'type'>,
): Question<'choice'> => ({ ...question, type: 'choice' })

export const createQuestionImageChoice = (
  question: Omit<Question<'imageChoice'>, 'type'>,
): Question<'imageChoice'> => ({ ...question, type: 'imageChoice' })

export const createQuestionNps = (question: Omit<Question<'nps'>, 'type'>): Question<'nps'> => ({
  ...question,
  type: 'nps',
})

export const createQuestionOpenText = (
  question: Omit<Question<'openText'>, 'type'>,
): Question<'openText'> => ({ ...question, type: 'openText' })

export const createQuestionVideo = (
  question: Omit<Question<'video'>, 'type'>,
): Question<'video'> => ({
  ...question,
  type: 'video',
})

export const createQuestionRanked = (
  question: Omit<Question<'ranked'>, 'type'>,
): Question<'ranked'> => ({
  ...question,
  type: 'ranked',
})

export const createQuestionGaborGranger = (
  question: Omit<Question<'gaborGranger'>, 'type'>,
): Question<'gaborGranger'> => ({
  ...question,
  type: 'gaborGranger',
})
